/* Tooltip bubble — matches Figma nodes 2849:1350 and 2849:1354 (Web Player / Tooltips) */

.tooltip {
  display: flex;
  align-items: center;
  gap: var(--spacing\/1, 8px);
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  background: rgba(0, 0, 0, 0.90);
  border-radius: var(--radius\/sm, 4px);
  box-shadow:
    0 2px 2px 0 rgba(0, 0, 0, 0.24),
    0 4px 4px 0 rgba(0, 0, 0, 0.12);
  white-space: nowrap;
  /* Positioned by the wrapper via CSS Modules */
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  /* Hidden by default; shown via .wrapper:hover in the consuming component */
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  z-index: 10;
}

.visible {
  opacity: 1;
  pointer-events: auto;
}

.label {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: 400;
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
}

/* Keyboard shortcut badge */
.shortcut {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  padding: 0 var(--spacing\/1, 8px);
  border: 2px solid rgba(79, 152, 255, 0.3);
  border-radius: var(--radius\/sm, 4px);
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: 400;
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  opacity: 0.75;
  text-align: center;
  max-height: 24px;
}
